import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
	root: {
		textAlign: 'center',
		marginTop: theme.spacing(8),
	},
	heading: {
		marginRight: `${theme.spacing(1)} !important`,
	},
}));

function NoResults({ type, children }) {
	// can pass in type or simply pass type as child, simpler API to remember
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<div className={classes.root}>
			<Typography variant="heading1" className={classes.heading}>
				0
			</Typography>
			<Typography variant="heading4">
				{t(`common:no_${type || children}_found`)}
			</Typography>
		</div>
	);
}

NoResults.propTypes = {
	type: PropTypes.string,
	children: PropTypes.string,
};

export default React.memo(NoResults);
